<template>
   
    <div class="float-right" v-if="canCreate">
      &nbsp;
      <router-link :to='url' class="btn btn-success">{{ title }}</router-link>
    </div>
</template>

<script>
  import permission from '../permission'

  export default {
    name: 'CreateButton',
    props: {
      name: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        url: '',
        canCreate: true,
      }
    },
    watch: {
      name: {
        handler: function(newValue, oldValue) {
          let props = this.$router.resolve({
            name: this.name,
          })
  
          this.url = props.href
          this.canCreate = permission.checkPermission(props.resolved.meta.permission)
        },
        immediate: true,
      },
    },
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/shared/components/CreateButton.vue